import React from 'react'
import PropTypes from 'prop-types'
import * as styles from './styles'

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'compact', 'wide']),
  textAlign: PropTypes.oneOf(['left', 'center', 'right'])
}

const defaultProps = {
  className: '',
  variant: 'default',
  textAlign: 'center'
}

const KnowledgeGardenSection = ({ children, className, variant, textAlign }) => {
  return (
    <styles.Container className={className} variant={variant}>
      <styles.ContentWrapper variant={variant} textAlign={textAlign}>
        {children}
      </styles.ContentWrapper>
    </styles.Container>
  )
}

KnowledgeGardenSection.propTypes = propTypes
KnowledgeGardenSection.defaultProps = defaultProps

export default KnowledgeGardenSection